// Shared gap-match screen-reader live region, appended to <body> (outside #appContentContainer)
// so announcements are not captured into student notes.
const REGION_ID = 'gapMatchLiveRegion';

// Owned here rather than per GapChoice: every instance announces into the one region, so a newer
// announcement must supersede an older scheduled one.
let pendingTimeout;

// Several interactions can share the region (all-view, ENABLE_TWO_INLINE_GAP_MATCH_AREAS), so it is
// only cleared once the last one has unmounted.
let activeInteractions = 0;

const cancelPending = () => {
    if (pendingTimeout) {
        clearTimeout(pendingTimeout);
        pendingTimeout = undefined;
    }
};

const getRegion = () => {
    let region = document.getElementById(REGION_ID);
    if (!region) {
        region = document.createElement('div');
        region.id = REGION_ID;
        region.className = 'sr-only';
        region.setAttribute('aria-live', 'assertive');
        region.setAttribute('aria-atomic', 'true');
        document.body.appendChild(region);
    }
    return region;
};

const clearRegion = () => {
    cancelPending();

    const region = document.getElementById(REGION_ID);
    if (region) {
        region.textContent = '';
    }
};

const gapMatchLiveAnnouncer = {
    announce(message) {
        if (!message) {
            return;
        }
        cancelPending();
        getRegion().textContent = message;
    },

    /**
     * Announces after a delay, superseding any previously scheduled announcement.
     * @param {number} delay milliseconds to wait
     * @param {function(): (string|undefined)} getMessage evaluated when the delay elapses, so the
     *        message reflects the state then rather than at scheduling time
     */
    announceAfter(delay, getMessage) {
        cancelPending();
        pendingTimeout = setTimeout(() => {
            pendingTimeout = undefined;
            const message = getMessage();
            if (message) {
                getRegion().textContent = message;
            }
        }, delay);
    },

    // A move that announces nothing - a removal, or a key press with nowhere to go - must still
    // drop any scheduled paragraph, which would otherwise describe state that has since changed.
    cancelPending,

    // Created on mount rather than on first announcement: a region created and filled in the same
    // task is often missed by screen readers.
    register() {
        activeInteractions += 1;
        getRegion();
    },

    // Empties the region once the last interaction has gone, so its final announcement is not left
    // exposed to browse mode after navigating away.
    unregister() {
        activeInteractions = Math.max(0, activeInteractions - 1);
        if (activeInteractions === 0) {
            clearRegion();
        }
    },
};

export default gapMatchLiveAnnouncer;
